<template>
    <modal
        :value="value"
        :title="$t('message.termsOfUse.message.dataController')"
        max-width="720"
        @input="closeModal"
        :has-padding="false"
    >
        <form class="data-controller-form" @submit.prevent="onDataControllerSubmit">
            <v-text-field :label="$t('message.termsOfUse.message.dataControllerFullName')"
                v-model="form.name"
                v-validate="'required'"
                :name="$t('message.termsOfUse.message.dataControllerFullName')"
                :error-messages="errors.collect($t('message.termsOfUse.message.dataControllerFullName'))"
            ></v-text-field>

            <v-text-field label="E-mail"
                v-model="form.email"
                v-validate="'required'"
                name="email"
                :error-messages="errors.collect('email')"
            ></v-text-field>

            <v-text-field :label="$t('message.termsOfUse.message.dataControllerRole')"
                v-model="form.role"
                v-validate="'required'"
                :name="$t('message.termsOfUse.message.dataControllerRole')"
                :error-messages="errors.collect($t('message.termsOfUse.message.dataControllerRole'))"
            ></v-text-field>

            <v-text-field label="CPF"
                v-model="form.cpf"
                v-validate="'required'"
                mask="###.###.###-##"
                name="CPF"
                :error-messages="errors.collect('CPF')"
            ></v-text-field>

            <v-text-field :label="$t('message.termsOfUse.message.dataControllerPhoneNumber')"
                v-model="form.phoneNumber"
                mask="(##) #####-####"
                v-validate="'required'"
                :name="$t('message.termsOfUse.message.dataControllerPhoneNumber')"
                :error-messages="errors.collect($t('message.termsOfUse.message.dataControllerPhoneNumber'))"
            ></v-text-field>

            <v-text-field :label="$t('message.termsOfUse.message.dataControllerBirthdate')"
                v-model="form.birthdate"
                mask="##/##/####"
                :name="$t('message.termsOfUse.message.dataControllerBirthdate')"
                :error-messages="dateErrorMessage || errors.collect($t('message.termsOfUse.message.dataControllerBirthdate'))"
            ></v-text-field>
            <button
                class="btn btn-primary data-controller-form-btn"
                :disabled="Boolean(dateErrorMessage) || Boolean(errors.items.length)"
            >{{ $t('message.termsOfUse.message.dataControllerSave') }}</button>
        </form>
    </modal>
</template>

<script>
import Modal from "@/components/generic/Modal";
import EventBus from "@packages/event-bus";
import moment from "moment";

export default {
    components: {
        Modal
    },

    props: {
        value: {
            type: Boolean,
            default: false,
        },
        userDataController: {
            type: Object
        }
    },

    data(){
        return {
            dateErrorMessage: '',
            form: {
                name: '',
                email: '',
                cpf: '',
                birthdate: '',
                role: '',
                phoneNumber: ''
            }
        }
    },

    mounted() {
        this.form = this.userDataController;

        if(this.userDataController.birthdate) {
            this.form.birthdate = moment(this.userDataController.birthdate).format('DDMMYYYY')
        }
    },

    watch: {
        form: {
            handler({ birthdate }) {
                this.dateErrorMessage = ''

                if (birthdate.length !== 8) return

                const formattedDate = moment(birthdate, "DDMMYYYY", true);

                if(!formattedDate.isValid()){
                    this.dateErrorMessage =  this.$t("message.termsOfUse.message.dataControllerInvalidDate")
                }

                if(formattedDate.isAfter(moment()) ) {
                    this.dateErrorMessage = this.$t("message.termsOfUse.message.dataControllerDateGreaterError")
                }
            },
            deep: true
        }
    },

    methods: {
        async onDataControllerSubmit() {
            const date = this.form.birthdate ? moment(this.form.birthdate, "DDMMYYYY", true).format('YYYY-MM-DD') : ''

            try {
                await this.$api.dataController.update({
                    ...this.form,
                    birthdate: date
                });

                EventBus.$emit('show-message', {
                    type: "SUCCESS",
                    message: this.$t("message.termsOfUse.message.dataControllerUpdated")
                });

                this.closeModal();
            } catch (error) {
                console.log(error)
            }
        },

        closeModal(value) {
            this.$emit("input", value);
        }
    }
}

</script>

<style lang="scss" scoped>
.data-controller-form {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 32px;
}

.data-controller-form-btn {
    margin-top: 16px;
    align-self: center;
}
</style>
